export default __webpack_public_path__ + "static/N0151-8a62ae4e8223661173cc801720624d9d.png";